module.exports = __webpack_public_path__ + "assets/aeebb77d15665b61a337c210d8968871.mp3";